import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { MongodbConnector } from '../../connector';

export const MongodbService = IntegrationService.make({
  connector: MongodbConnector,
  name: Integration_Service_Names_Enum.Mongodb,
});
